import React from 'react';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { parseSlug } from '../archives-utils/archivesUtils';
import play from '../../../assets/icons/play-54-4b7fa8b71484507993b8958a4124dcce.png';
import styles from '../css/Archives.module.css';
import SfwImage from '../../../components/AgeVerificationComponents/SfwImage';
import { RootStoreContext } from '../../../context';
import { getCookie } from '../../../utils/helpers';
import { PROMO_CODES } from '../../../constants/promoCodes';


const PARTNER_SOURCE = 'partnerSource';

class Arhive extends React.Component {
  static contextType = RootStoreContext;
  constructor(...args) {
    super(...args);
    this.dayjs = dayjs;
    this.dayjs.extend(utc);
  }

  render() {
    const { arhive, typeOfListing, listingId, slug, searchFullText } = this.props;
    const imageLink = (arhive.clipView && arhive.clipView.thumbnailImageUrl) ? arhive.clipView.thumbnailImageUrl : arhive.image;
    const date = arhive?.publishedAt || arhive?.date;
    const user = this.context;
    const title = arhive?.title || arhive?.name;
    let parsedSlug = parseSlug(arhive, typeOfListing, listingId, slug, searchFullText);
    const utcDate = this.dayjs(date).utc();


    const doesNotHaveMembership = !user?.loggedInUser?.activeSubscription;
    if (doesNotHaveMembership && getCookie(PARTNER_SOURCE) === PROMO_CODES.ANCHOR_AFFILIATE) {
      const urlParams = new URLSearchParams(window.location.search);
      parsedSlug = `/affiliate/anchor-signup?_anchor=${urlParams.get('anchorid')}&disableRedirect=1`;
    }


    return (
      <div className="col-md-3 col-sm-4 col-xs-12">
        <div className="thumbnail" title={title}>
          <Link className="lazy video" to={parsedSlug}>
            <SfwImage
              alt="Xlthumb placeholder"
              className="img-responsive video-thumbnail"
              nsfwImage={imageLink}
              sfwImage={arhive?.sfwAssetImage}
              style={{ opacity: 1 }}
            />
            <img
              alt="Play 54"
              className="play-icon"
              src={play}
            />
          </Link>
          <div className={styles.caption}>
            {typeOfListing === 'date' || typeOfListing === 'all' ? (
              <div className={styles.linkContainer}>
                <Link className={styles.title} to={parsedSlug}>
                  {title}
                </Link>
                {typeOfListing !== 'vintage' && (
                  <h6 className="text-muted">{utcDate.format('dddd LL')}</h6>
                )}
              </div>
            ) : (
              <div className={styles.linkContainer}>
                <Link className={styles.title} to={parsedSlug}>{title}</Link>
                {typeOfListing !== 'vintage' && (
                  <h6 className="text-muted">{utcDate.format('dddd LL')}</h6>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Arhive;
